import api from 'ApiConfig';

const learningMaterial = {
  createTrainingMaterial: async (data) => {
    return api.post('/teacher/create-training-material', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getMaterialsByStructure: async (batchStructureId, courseId) => {
    return api.get(`/teacher/get-materials-by-structure`, {
      params: { batchStructureId, courseId },
    });
  },
  getTrainingMaterial: async (batchId, courseId) => {
    return api.get(`/teacher/get-training-material`, {
      params: { batchId, ...(courseId && { courseId }) },
    });
  },
  createvideoUrl: async (data) => {
    return api.post('/teacher/create-video-url', data);
  },
  getLectureVideoLinks: async (data) => {
    return api.post('/teacher/get-video-url', data);
  },
  updateLectureVideoLinks: async (data, id) => {
    const payload = {
      ...data,
      id,
    };

    return api.post('/teacher/update-video-url', payload);
  },
  getMaterialLinksByBatchAndCourse: async (data) => {
    return api.post('/teacher/get-link-url', data);
  },
  updateMaterialLinks: async (data, id) => {
    const payload = {
      ...data,
      id,
    };

    return api.post('/teacher/update-link-url', payload);
  },
  deleteMaterialLinks: async (id) => {
    return api.post('/teacher/delete-link-url', { id });
  },
  deleteVideoUrl: async (id) => {
    return api.post('/teacher/delete-video-url', { id });
  },
  createTrainingMaterialUrl: async (data) => {
    return api.post('/teacher/assign-training-material-url', data);
  },
  getTrainingMaterialUrls: async (params) => {
    return api.get('/teacher/get-training-material-urls', { params });
  },
  updateTrainingMaterialUrl: async (id, data) => {
    return api.put(`/teacher/training-material-urls/${id}`, data);
  },
  deleteTrainingMaterialUrl: async (id) => {
    return api.delete(`/teacher/training-material-urls/${id}`);
  },
};

export default learningMaterial;
